<template>
  <div>
    <img :src="imgList[tmpType-1]" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    tmpType: String,
  },
  data() {
    return {
      imgList: [
        'https://img3.quanyou.com.cn/joy/group1/M00/19/B0/rB4ChWNmDW-AVm31AAFtbVoB9gc205.png',
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1C/C3/rB8LrWUuAbyAOEpyAAGbQcDCIoU388.png',
        require('@/assets/images/styleTwo/pt.png'),
        require('@/assets/images/styleFour/pt.png'),
        require('@/assets/images/styleFive/pt.png'),
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
  img {
    width:  100%;
    height: 100%;
  }
</style>